import { FEEDBACK_LIMITS } from '@clockwise/shared';
import { z } from 'zod';

// Re-export the cross-cutting constants so the frontend can import them
// directly from `@clockwise/clients/feedback` alongside the client class
// (the api side imports them straight from `@clockwise/shared`).
export { FEEDBACK_ALLOWED_CONTENT_TYPES, FEEDBACK_LIMITS } from '@clockwise/shared';

export const feedbackContextSchema = z.object({
  url: z.string().min(1),
  userAgent: z.string().min(1),
  viewport: z.string().optional(),
  timestamp: z.string().min(1),
});

export const submitFeedbackSchema = z.object({
  subject: z.string().min(1).max(FEEDBACK_LIMITS.maxSubjectLength),
  message: z.string().min(1).max(FEEDBACK_LIMITS.maxMessageLength),
  context: feedbackContextSchema,
});

export type FeedbackContext = z.infer<typeof feedbackContextSchema>;
export type SubmitFeedbackRequest = z.infer<typeof submitFeedbackSchema>;

export interface SubmitFeedbackResponse {
  status: 'sent';
  messageId: string | null;
}
